import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription, throwError, Observable } from 'rxjs';
import { tap, catchError, map } from 'rxjs/operators';

// INTERFACES
import { IPagination } from '../../interfaces/paginator.interface';

// SERVICES
import { EnvironmentUtilService } from '../util';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ProductSubstitutionApiService {
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  getProductSubstitutesByProductId(data :{
    params :{ [param :string] :string | string[] };
  }) :Observable<any> {
    const { params = {} } = data;

    return this.apiService.get(
      `${this.environment.urlV2}/products/product-substitutions`,
      {
        params,
      },
    );
  }

  detachProductSubstitute(id :number) :Observable<any> {
    return this.apiService.delete(
      `${this.environment.urlV2}/products/product-substitutions/${id}`,
    );
  }

  addProductSubstitute(
    productId :number,
    substituteProductId :number,
    priority :number,
  ) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/products/product-substitutions`,
      body: {
        productId,
        substituteProductId,
        priority,
      },
    });
  }

  updatePriorities(items :any) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/products/product-substitutions/update-priorities`,
      body: {
        items,
      },
    });
  }
}
